import{a as e}from"./chunk-2HA4XQFN.js";var t=e(r=>r*(Math.PI/180),"degreesToRadians");export{t as a};
